import { api } from '../configs/axiosConfigs';
import { EmailDocKind } from '../../utility/listingEmail';

export const getEmailAttachments = async () => api.get('/email_attachments');

// Sends the file as multipart form data. A new proof of funds replaces the old one.
export const uploadEmailAttachment = async (input: { file: File; kind: EmailDocKind; name?: string }) => {
  const form = new FormData();
  form.append('file', input.file);
  form.append('kind', input.kind);
  if (input.name) form.append('name', input.name);
  return api.post('/email_attachments', form, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const updateEmailAttachment = async (id: string, values: { name?: string; attach_by_default?: boolean }) =>
  api.patch(`/email_attachments/${id}`, values);

export const deleteEmailAttachment = async (id: string) => api.delete(`/email_attachments/${id}`);
